import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, signal, SimpleChanges } from '@angular/core';
import { IInvoice } from '@rfm/shared-interfaces';

@Component({
  selector: 'app-most-recent-invoice',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './most-recent-invoice.component.html',
  styleUrls: ['./most-recent-invoice.component.scss']
})
export class MostRecentInvoiceComponent implements OnInit, OnChanges {
  @Input()
  latest_invoice = signal<IInvoice | undefined>(undefined);

  hasInvoice: boolean = false;

  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.latest_invoice())
    {
      this.hasInvoice = true;
    }
    else
    {
      this.hasInvoice = false;
    }
  }

  ngOnInit() {
  }

  downloadLatest() {
    window.open(this.latest_invoice()?.document_url, '_blank');
  }

}
